import {ssrSafeWindow} from '@github-ui/ssr-utils'

export const FETCH_NONCE_HEADER = 'X-Fetch-Nonce'
export const FETCH_NONCE_TO_VALIDATE_HEADER = 'X-Fetch-Nonce-To-Validate'

const nonce = ssrSafeWindow?.document?.head?.querySelector<HTMLMetaElement>('meta[name="fetch-nonce"]')?.content || ''
export const fetchNonces = new Set<string>()

if (nonce) addValidNonce(nonce)

export function addValidNonce(newNonce: string) {
  fetchNonces.add(newNonce)
}

export function getFetchNonce() {
  return fetchNonces.values().next().value || ''
}

export function getFetchNonceHeaders(nonceToValidate?: string) {
  const headers: HeadersInit = {}

  if (nonceToValidate) {
    headers[FETCH_NONCE_TO_VALIDATE_HEADER] = nonceToValidate
  }

  if (nonceToValidate && fetchNonces.has(nonceToValidate)) {
    headers[FETCH_NONCE_HEADER] = nonceToValidate
  } else {
    headers[FETCH_NONCE_HEADER] = Array.from(fetchNonces).join(',')
  }

  return headers
}
